import { Component, OnInit } from '@angular/core';
//import { PaginationInstance } from 'ng2-pagination';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-pagamenti-riepilogo',
  templateUrl: './pagamenti-riepilogo.component.html',
  styleUrls: ['./pagamenti-riepilogo.component.css']
})
export class PagamentiRiepilogoComponent extends AppComponentGenericComponent implements OnInit {
	pagamenti: any[] = [];
	pagamentiFiltered: any[] = [];
	pagamentoSelected: any = null;
	pagamentiSync: Subscription;

	emissioni: any[] = [];
	emissionSelected = "all";
	emissioniSync: Subscription;

	/*public config: PaginationInstance = {
		id: 'custom',
		itemsPerPage: 30,
		currentPage: 1
	};*/

	pagatoTotale : number = 0.00;
	loading: boolean = false;
	numPag: any = 0;

	modalInput: any = {
		size: 'modal-95',
		title: 'Titolo',
		subtitle: 'sottotitolo',
		data: {
			id: 0,
			person : null,
			id_prat: null,
			notifica: null,
			pagamento: null,
			reset: false,
		}
	};

	constructor(protected dataService: DataService) {
		super(dataService, 'pagamenti-riepilogo');
	}

	ngOnInit() {
		this.emissioniSync = this.dataService.emissioni$.subscribe(
			emissioni => {
				this.emissioni = emissioni;
			});
		this.pagamentiSync = this.dataService.pagamenti$.subscribe(
			pagamenti => {
				this.pagamenti = pagamenti;
				this.pagamentiFiltered = this.pagamenti;
				this.calcSummedValue();
			});
	}

	onSelect(pagamento: any){
		this.pagamentoSelected = pagamento;
		this.modalInput = {
			size: 'large-modal',
			title: 'Pagamento Dettaglio',
			subtitle: 'Pratica: ' + pagamento.pratica_id,
			data: {
				pagamento: pagamento,
			}
		};
		console.log('pagamentoSelected', this.pagamentoSelected);
	}

	calcSummedValue(){
		this.numPag = 0;
		this.pagatoTotale = 0.00;
		if(this.pagamentiFiltered){
			for(let pagamento of this.pagamentiFiltered){
					this.pagatoTotale += Number(pagamento.sommaPagata);
			}
			this.numPag = this.pagamentiFiltered.length;
		}
		console.log("PAGAMENTI-RIEPILOGO|PAGATO:", this.pagatoTotale);
	}

	checkEmissionFilter(pagamento: any) {
		if(this.emissionSelected == "all"){
			return true;
		}
		else if(pagamento.emissione_id == this.emissionSelected){
			return true;
		}else{
			return false;
		}
	}

	find(){
		setTimeout(()=>{ this.goLoading(); }, 100);
		setTimeout(()=>{ this.applyFilter(); }, 500);
	}

	goLoading(){
		this.loading = true;
	}

	applyFilter(){
		this.pagamentiFiltered = [];
		if(this.pagamenti){
			for(let pagamento of this.pagamenti){
				pagamento.id_prat = Number(pagamento.id_prat);
				if(this.checkEmissionFilter(pagamento)){
					this.pagamentiFiltered.push(pagamento);
				}
			}
		}
		this.calcSummedValue();
		this.loading = false;
	}

	resetFilters(){
		this.emissionSelected = "all";
		this.loading = false;
		this.applyFilter();
	}

	ngOnDestroy() {
		this.emissioniSync.unsubscribe();
		this.pagamentiSync.unsubscribe();
	}
}
